import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const DAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

const statusFor = (o) => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", { timeZone: o.tz, weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
      .formatToParts(new Date())
      .map((p) => [p.type, p.value])
  );
  const mins = Number(parts.hour) * 60 + Number(parts.minute);
  const open = o.days.includes(DAY[parts.weekday]) && mins >= o.open && mins < o.close;
  return { open, time: `${parts.hour}:${parts.minute}` };
};

export default function OfficeHours({ office, light = false }) {
  const [s, setS] = useState(() => statusFor(office));
  useEffect(() => {
    const t = setInterval(() => setS(statusFor(office)), 30000);
    return () => clearInterval(t);
  }, [office]);
  const muted = light ? "text-ivory/70" : "text-charcoal-soft";
  return (
    <div className="flex gap-3" data-testid={`office-hours-${office.city.toLowerCase()}`}>
      <Clock className={`mt-0.5 h-4 w-4 shrink-0 ${light ? "text-gold" : "text-gold-deep"}`} strokeWidth={1.5} />
      <div>
        <p>{office.hoursText} <span className={muted}>({office.tzLabel})</span></p>
        <p className={`mt-1 flex items-center gap-2 text-[12px] ${muted}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${s.open ? "bg-emerald-500" : "bg-gold"}`} />
          <span data-testid={`office-status-${office.city.toLowerCase()}`}>{s.open ? "Open now" : "Closed now"} · {s.time} local time</span>
        </p>
      </div>
    </div>
  );
}
